import { LocationType } from "@/types/location-params-type";

export const getForecastLocationIdParams = (
	locationType: LocationType,
): string | null => {
	const searchParams = new URLSearchParams(window.location.search);
	return searchParams.get(locationType);
};

export const handleSetLocationId = ({
	locationType,
	locationId,
}: {
	locationType: LocationType;
	locationId: string | number;
}): void => {
	const currentUrl = window.location.pathname;
	const searchParams = new URLSearchParams(window.location.search);

	searchParams.set(locationType, locationId.toString());

	const newUrl = `${currentUrl}?${searchParams.toString()}`;

	window.history.pushState({}, "", newUrl);
};
